import { theme } from '../theme';
import { isNullOrUndefined } from '../../utils/typeUtils';

const getCss = (cssProperties, index) =>
  // oxlint-disable-next-line no-array-reduce
  Object.keys(cssProperties).reduce((cssString, cssProperty) => {
    if (Array.isArray(cssProperties[cssProperty])) {
      if (!isNullOrUndefined(cssProperties[cssProperty][index])) {
        return `${cssString}${cssProperty}: ${cssProperties[cssProperty][index]};`;
      }
      return cssString;
    }
    if (index === 0 && !isNullOrUndefined(cssProperties[cssProperty])) {
      return `${cssString}${cssProperty}: ${cssProperties[cssProperty]};`;
    }
    return cssString;
  }, '');

// facePaint do not know anything about scale values
// and how to resolve them. Any value passed to facePaint
// must have been already resolved.
export const facePaint = cssProperties => {
  let styles = '';
  theme.breakpoints.sorted.forEach((bp, index) => {
    // First breakpoint doesn't need media-queries
    if (index === 0) {
      styles = styles.concat(getCss(cssProperties, 0));
    } else {
      const mqStyles = getCss(cssProperties, index);
      if (mqStyles) {
        styles = styles.concat(`${theme.mq[bp.name]} {
          ${mqStyles}
        }`);
      }
    }
  });
  return styles;
};
